import { render, staticRenderFns } from "./PageTextConfig.vue?vue&type=template&id=0d7122a5"
import script from "./PageTextConfig.vue?vue&type=script&lang=js"
export * from "./PageTextConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports